import { useMemo, useEffect, useState, useCallback } from 'react';
import { enumHelper, ORDER_STATUSES, dateHelper, isSkeletonLoading, rowFilterHelper } from 'shared';

export const useViewOrderHistoryBuildTable = (inputs = [], t, sorting) => {
  const [rows, setRows] = useState([]);
  const [initialRows, setInitialRows] = useState([]);

  const orderStatusesElements = useMemo(() => {
    return enumHelper.enumToFilter(ORDER_STATUSES, t, 'statuses');
  }, [t]);

  const headCells = useMemo(() => {
    return [
      {
        id: 'status',
        numeric: false,
        disablePadding: true,
        label: t('history.properties.status')
      },
      {
        id: 'date',
        numeric: false,
        disablePadding: true,
        label: t('history.properties.date')
      }
    ];
  }, [t]);

  useEffect(() => {
    const rowsMapped = !inputs.length
      ? []
      : inputs
      ? inputs.map(orderHistory => ({
          id: orderHistory.id,
          status: isSkeletonLoading(orderHistory.status)
            ? orderHistory.status
            : orderStatusesElements &&
              orderStatusesElements.filter(f => f.value === orderHistory.status.toString())[0].name,
          date: isSkeletonLoading(orderHistory.date)
            ? orderHistory.date
            : dateHelper.toLongDate(orderHistory.date.toString())
        }))
      : [];
    setInitialRows(rowsMapped);
    setRows(rowsMapped.sort((a, b) => (dateHelper.convertToDate(a.date) < dateHelper.convertToDate(b.date) ? -1 : 1)));
  }, [inputs, sorting.orderBy, t, orderStatusesElements]);

  const getHistory = useCallback(
    ({ paging, sorting, filteredCells }) => {
      setRows(rowFilterHelper.getFilteredRows(initialRows, filteredCells, sorting));
    },
    [initialRows]
  );

  return { headCells, rows, getHistory };
};
